import "./OutputCard.css";

function OutputCard(props){

    return(
        <div className='output-card'>
            <h3>{props.name}</h3>
            <pre>{props.data}</pre>
            <p>{props.desc}</p>
        </div>
    );
}

export default OutputCard;